import {
    CREDIT_APP_SEARCH_OPEN_SLIDEOUT,
    CREDIT_APP_SEARCH_CLOSE_SLIDEOUT,
    CREDIT_APP_SEARCH_MERGE_DEAL,
    CREDIT_APP_SEARCH_SHOW_SAVE_REMINDER,
    CREDIT_APP_SEARCH_HIDE_SAVE_REMINDER
} from '../actionTypes/creditAppSearchActionTypes';
import type { IDealSearchDeal } from '@makemydeal/dr-shared-bff-types';

export const openCreditAppSearchSlideout = () => ({
    type: CREDIT_APP_SEARCH_OPEN_SLIDEOUT
});

export const closeCreditAppSearchSlideout = () => ({
    type: CREDIT_APP_SEARCH_CLOSE_SLIDEOUT
});

/**
 * Action creator to merge selected credit app deal data into the current deal
 * Accepts the complete raw deal data from the search API response (IDealSearchDeal)
 */
export const mergeCreditAppDeal = (
    rawDeal: IDealSearchDeal,
    previousDealRefId: string | undefined,
    enableCorrectPhoneHandling?: boolean
) => ({
    type: CREDIT_APP_SEARCH_MERGE_DEAL,
    payload: rawDeal,
    meta: {
        middleware: {
            payment: true
        },
        previousDealRefId,
        enableCorrectPhoneHandling
    }
});

export const showCreditAppSearchSaveReminder = () => ({
    type: CREDIT_APP_SEARCH_SHOW_SAVE_REMINDER
});

export const hideCreditAppSearchSaveReminder = () => ({
    type: CREDIT_APP_SEARCH_HIDE_SAVE_REMINDER
});
